"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translations = exports.getMessages = void 0;
var _flat = _interopRequireDefault(require("flat"));
var _en = require("./en");
var _zh = require("./zh");
// Copyright © 2021 LexisNexis Risk Solutions Group

const translations = exports.translations = {
  en: (0, _flat.default)(_en.en),
  zh: (0, _flat.default)(_zh.zh)
};
const getMessages = locale => key => {
  if (locale === 'en' || locale === 'zh') {
    return translations[locale][key];
  }
  return translations.en[key];
};
exports.getMessages = getMessages;